import {
  getLeoUuid,
  LeoUUID,
  getObject,
} from "@surya-digital/leo-ts-types";
import { UserName, UserNameDTO } from "../types/userName";
import { KeycloakEmail, KeycloakEmailDTO } from "../types/keycloakEmail";

export interface BOUserDetailsDTO {
  boUserId: string;
  userName: UserNameDTO;
  emailId: KeycloakEmailDTO;
}

export class BOUserDetails {
  readonly isBOUserDetailsBOUserDetails: boolean = true;

  readonly boUserId: LeoUUID;
  readonly userName: UserName;
  readonly emailId: KeycloakEmail;


  constructor(
  boUserId: LeoUUID, 
  userName: UserName, 
  emailId: KeycloakEmail
  ) {
    this.boUserId = boUserId;
    this.userName = userName;
    this.emailId = emailId;
  }

  static fromDTO(dto: BOUserDetailsDTO): BOUserDetails {
    const boUserId = getLeoUuid(dto, "boUserId", InvalidBOUserDetailsBoUserIdError);
    const userName = UserName.fromDTO(getObject(dto, "userName", InvalidBOUserDetailsUserNameError));
    const emailId = KeycloakEmail.fromDTO(getObject(dto, "emailId", InvalidBOUserDetailsEmailIdError));
    return new BOUserDetails(
      boUserId,
      userName,
      emailId
    );
  }

  toDTO(): BOUserDetailsDTO {
    const dto: BOUserDetailsDTO = {
        boUserId: this.boUserId.toDTO(),
        userName: this.userName.toDTO(),
        emailId: this.emailId.toDTO()
    };
    return dto;
  }
  }

BOUserDetails.prototype.toString = function toString(): string {
  return `BOUserDetails(boUserId='${this.boUserId}',userName='${this.userName}',emailId='${this.emailId}')`;
};

export class InvalidBOUserDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUserDetailsError";
  }
}
export class InvalidBOUserDetailsBoUserIdError extends InvalidBOUserDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUserDetailsBoUserIdError";
  }
}

export class InvalidBOUserDetailsUserNameError extends InvalidBOUserDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUserDetailsUserNameError";
  }
}

export class InvalidBOUserDetailsEmailIdError extends InvalidBOUserDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBOUserDetailsEmailIdError";
  }
}
